import { useEffect } from "react";
import { useLocation } from "react-router-dom";

/**
 * On route change:
 *  - If the URL has a hash (e.g. /#contact), scroll that element into view
 *    once it has mounted (Index page sections are rendered after navigation).
 *  - Otherwise scroll to the top of the page.
 */
const ScrollToTop = () => {
  const { pathname, hash } = useLocation();

  useEffect(() => {
    if (hash) {
      const id = hash.replace("#", "");
      // Defer until after the new route's DOM has rendered.
      const scroll = () => {
        const el = document.getElementById(id);
        if (el) {
          el.scrollIntoView({ behavior: "smooth", block: "start" });
        } else {
          window.scrollTo({ top: 0, left: 0 });
        }
      };
      // Two RAFs handle both immediate and lazy-mounted sections.
      requestAnimationFrame(() => requestAnimationFrame(scroll));
      return;
    }
    window.scrollTo({ top: 0, left: 0 });
  }, [pathname, hash]);

  return null;
};

export default ScrollToTop;
